import type React from 'react'
import { Box, Container } from '@chakra-ui/react'
import FixedBar from '../../categories/fixed-bar'
import StaticBar from '../../categories/static-bar'
import { ICategory } from '@/_types'
import { ICategoryWithProducts } from '@/features/brand-menu'

interface CategoriesSectionProps {
  catalogRef: React.RefObject<HTMLDivElement | null>
  categories: ICategoryWithProducts[]
}

const CategoriesSection = ({
  catalogRef,
  categories,
}: CategoriesSectionProps) => (
  <Box pb={{ base: 4, lg: 0 }} zIndex={10}>
    <div ref={catalogRef}>
      <FixedBar data={categories} instanceRef={catalogRef} />
      <Container zIndex={1}>
        <StaticBar data={categories} />
      </Container>
    </div>
  </Box>
)

export default CategoriesSection
